export namespace Constants {
  export const EASY_EDUM_IS_USER_LOGGED_IN: string = "easy-edum-is-use-logged-in";
  export const APP_NAME: string = "My Campus Pilot";
  export const EASY_EDUM_LOGGED_IN_USER_TOKEN: string = "easy-edu-m-app-jwt-token";
  // renews the 1-hour access token (POST /auth/refresh) for up to 1 day after login
  export const EASY_EDUM_LOGGED_IN_USER_REFRESH_TOKEN: string = "easy-edu-m-app-refresh-token";
  // last click / key press (epoch millis), shared by all tabs; 45 minutes without one ends the session
  export const LAST_ACTIVITY_AT: string = "easy-edu-m-app-last-activity";
  export const EASY_EDUM_LOGGED_IN_USER_ID = "easy-edum-logged-in-user-name";
  export const EASY_EDUM_LOGGED_IN_USER_NAME = "EASY_EDUM_LOGGED_IN_USER_NAME";
  export const EASY_EDUM_LOGGED_IN_USER_ROLE = "easy-edum-logged-in-user-role";

  export const EASY_EDUM_LOGGED_IN_USER_ADMISSION_NO = "EASY_EDUM_LOGGED_IN_USER_ADMISSION_NO";
  export const EASY_EDUM_LOGGED_IN_USER_GRADES = "EASY_EDUM_LOGGED_IN_USER_GRADES";
  // desktop sidebar expanded/collapsed; cleared at every login so each session starts collapsed
  export const SIDEBAR_EXPANDED = "sidebar-expanded";
}

export namespace PaymentMode {
  export const CASH: string = "CASH";
  export const UPI: string = "UPI";
  export const BANK_TRANSFER: string = "BankTransfer";
  export const CHEQUE: string = "CHEQUE";
}

export namespace PaymentState {
  export const INITIATING_PAYMENT: string = "INITIATING_PAYMENT";
}

export namespace ComponentName {
  export const MODIFY_STUDENTS: string = "MODIFY_STUDENTS";
  export const FE_DUES: string = "FE_DUES";
  export const PROMOTE_STUDENTS: string = "PROMOTE_STUDENTS";
  export const FEE_REPORTS: string = "FEE_REPORTS";
}

export namespace PersonType {
  export const FATHER: string = "FATHER";
  export const MOTHER: string = "MOTHER";
  export const GUARDIAN: string = "GUARDIAN";
  export const EMERGENCY: string = "EMERGENCY";
}
